<template lang="pug">
div
  template(v-if="!isLoggedIn")
    register
    login
    forgotPassword
  template(v-else)
    review
    reviewComplete
  popupBanner
  tutorial
  partnerList
  .topnav
    .topnavbar
      .con
        .nlbar
          language
          .sidebar-menu.nb-sidebar-switch(@click="toggleSidebar" ref="sidebarToggle")
            img(src="/new/img/menu/menu.gif")
          .logo
            router-link(to="/")
              img(src='/new/img/logo.png')
        .nvbar
          .nbin(v-if="!isLoggedIn")
            a.btns(href='javascript:void(0)' @click="openModal('#logModal')") {{$t('ui.login')}}
            a.btns.s2(href='javascript:void(0)' @click="openModal('#regModal')")
              span.animate__animated.animate__flash.animate__infinite {{$t('ui.register')}}
          .nbin(v-if="isLoggedIn")
            .af-user.pointer
              img(@click="$router.push('/setting')" src='/new/img/af/user.png')
              .u-info(@click="$router.push('/deposit')")
                span.u-name {{accountID}} 
                span.u-amo PHP {{ $numeral($store.getters.balance).format("0,0.00") }}
              img(v-if="getVip!==''" :src="'/new/img/vip/'+getVip+'.png'" @click="$router.push('/vip')" src='/new/img/vip/bronze.png')
  .main-wrap
    sidebar(v-click-outside="closeSidebar")
    router-view
    depoProgress(v-if="currentPath === '/' && isLoggedIn")
  .btmnav
    router-link.btns2(to="/" :class="{'aaa': currentPath==='/'}")
      img(src='/new/img/menu/m/home.png')
      span Home
    router-link.btns2(to="/promotions" :class="{'aaa': currentPath==='/promotions'}")
      img(src='/new/img/menu/m/promo.png')
      span Promo
    router-link.btns2.hl(to="/deposit")
      img(src='/new/img/menu/m/deposit.png')
      span Deposit
    a.btns2(href="javascript:void(0)" @click="openChat")
      //- .notify.blink 1
      img(src='/new/img/menu/m/livechat.png')
      span Live Chat
    template(v-if="isLoggedIn")
      router-link.btns2(to="/inbox" :class="{'aaa': currentPath==='/inbox'}")
        img(src='/new/img/menu/m/rewards.png')
        span Rewards
    template(v-else)
      a.btns2(href="javascript:void(0)" @click="openModal('#logModal')")
        img(src='/new/img/menu/m/rewards.png')
        span Rewards
  .float-icon-wrap.nb-float-icon(v-if="currentPath==='/'" :class="{'close': hideIcon}" )
    .float-act.nb-float-act.border-0.pointer(@click="toggleIcon")
      .triangle.triangle-2
        i.fa-solid.fa-angle-right
    .float-icon
      a(v-if="!isIOS" href="https://dapk.epwin21.com/epicwin.apk" target="_blank")
        img(src='/new/img/side/app.png')
      a(v-if="isIOS" href='javascript:void(0)' @click="openTutorial")
        img(src='/new/img/side/app.png')
      a(href='https://epicwinvip.com/RF13560800' target="_blank")
        img(src='/new/img/side/partnership.gif')
      router-link(to="partners")
        img(src='/new/img/menu/group-m.png')
</template>
<script>
import config from "@/config";
import _ from "lodash";
import sidebar from "@/views/default/_sidebar.vue";
import topbar from "@/views/default/_topBar.vue";
import language from "@/component/_language.vue"
import tabList from "@/views/default/_tabs.vue";
import register from "@/component/_register.vue";
import login from "@/component/_login.vue";
import forgotPassword from "@/component/_forgotPassword.vue";
import popupBanner from "@/component/_popupBanner.vue";
import footerBanner from "@/views/default/_footerBanner.vue";
import footerInfo from "@/views/default/_footer.vue";
import footerArticle from "@/views/default/_footerArticle.vue";
import tutorial from "@/component/_tutorial.vue";
import review from "@/component/review/_review.vue";
import reviewComplete from "@/component/review/_reviewComplete.vue";
import depoProgress from "@/component/_depoProgress.vue"
import { EventBus } from '@/store/event';
import partnerList from "@/component/_partnerList.vue";
export default {
  metaInfo(){
    var site = window.location.protocol + "//" + window.location.hostname + "/";
    
    if(this.ph88.includes(site)){
      return {
        script: [
          {
            vmid: 'ga-script',
            src: 'https://www.googletagmanager.com/gtag/js?id=G-BLTBKNQWQ9',
            async: true,
          },
          {
            vmid: 'ga-config',
            innerHTML: `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', 'G-BLTBKNQWQ9');
            `,
            type: 'text/javascript',
            charset: 'utf-8'
          },
          {
            vmid: 'gtm-body',
            innerHTML: "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-TVG8S3NG');",
            type: 'text/javascript'
          }
        ],
        noscript: [
          {
            vmid: 'gtm-noscript',
            innerHTML: '<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-TVG8S3NG" height="0" width="0" style="display:none;visibility:hidden"></iframe>',
            pbody: true
          }
        ],
        __dangerouslyDisableSanitizers: ['script']
      };
    }else if(this.default.includes(site)){
      return {
        script: [
          {
            vmid: 'gtm-body',
            innerHTML: "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-5DWDGV3X');",
            type: 'text/javascript'
          }
        ],
        noscript: [
          {
            vmid: 'gtm-noscript',
            innerHTML: '<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-5DWDGV3X" height="0" width="0" style="display:none;visibility:hidden"></iframe>',
            pbody: true
          }
        ]
      }
    }else if(this.zz333.includes(site) || this.b222.includes(site) || this.s200.includes(site)){
      return {
        script: [
          {
            vmid: 'gtm-body',
            innerHTML: "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-TVG8S3NG');",
            type: 'text/javascript'
          }
        ],
        noscript: [
          {
            vmid: 'gtm-noscript',
            innerHTML: '<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-TVG8S3NG" height="0" width="0" style="display:none;visibility:hidden"></iframe>',
            pbody: true
          }
        ]
      }
    }else if(this.h2222.includes(site) || this.s4451.includes(site)){
      return {
        script: [
          {
            vmid: 'gtm-body',
            innerHTML: "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-T6NFQSCN');",
            type: 'text/javascript'
          }
        ],
        noscript: [
          {
            vmid: 'gtm-noscript',
            innerHTML: '<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-T6NFQSCN" height="0" width="0" style="display:none;visibility:hidden"></iframe>',
            pbody: true
          }
        ]
      }
    }else{
      return {
        script: [
          {
            vmid: 'ga-script',
            src: 'https://www.googletagmanager.com/gtag/js?id=G-2F07593391',
            async: true,
          },
          {
            vmid: 'ga-config',
            innerHTML: `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', 'G-2F07593391');
            `,
            type: 'text/javascript',
            charset: 'utf-8'
          }
        ],
        __dangerouslyDisableSanitizers: ['script']
      };
    }

    
  },
  components: {
    sidebar,
    tabList,
    topbar,
    language,
    register,
    login,
    forgotPassword,
    popupBanner,
    footerBanner,
    footerInfo,
    footerArticle,
    tutorial,
    review,
    reviewComplete,
    depoProgress,
    partnerList
  },
  directives: {
    clickOutside: {
      bind(el, binding, vnode) {
        // Handler for click outside event
        el.__ClickOutsideHandler__ = function (event) {
          // Ensure that the click target is not the sidebar itself
          if (window.innerWidth < 768 && !el.contains(event.target) && !vnode.context.$refs.sidebarToggle.contains(event.target)) {
            // Execute the passed method (closeSidebar)
            binding.value();
          }
        };
        // Add click event listener to body
        document.body.addEventListener('click', el.__ClickOutsideHandler__);
      },
      unbind(el) {
        // Clean up event listener when directive is destroyed
        document.body.removeEventListener('click', el.__ClickOutsideHandler__);
        el.__ClickOutsideHandler__ = null;
      }
    }
  },
  data() {
    return {
      showMobile: false,
      showTop: false,
      showBalance: false,
      showProfile:false,
      currentPath: "",
      hideIcon: false,
      refreshVip:null,
      refreshBalance: null,
      hideAnn: false,
      feedback: {
        success: true,
        status: ""
      },
      showSb: false,
      levels:[708,709,
        707,
        710,
        711,
        712,
        800,
        801,
        802,
        803,
      ],
      default:[
        "https://epicwin.ph/",
        "http://epicwin.ph/",
        "https://www.epicwin.ph/",
        "http://www.epicwin.ph/"
      ],
      ph88:[
        "https://epicwinph88.com/",
        "http://epicwinph88.com/",
        "https://www.epicwinph88.com/",
        "http://www.epicwinph88.com/"
      ],
      globeArray: [
        "http://www.epic888.asia/",
        "http://www.epic888.cc/",
        "http://www.epic888.co/",
        "http://www.epic888.net/",
        "https://www.epic888.asia/",
        "https://www.epic888.cc/",
        "https://www.epic888.co/",
        "https://www.epic888.net/"
      ],
      smartArray: [
        "http://www.epic8888.asia/",
        "http://www.epic8888.cc/",
        "http://www.epic8888.co/",
        "http://www.epic8888.com/",
        "https://www.epic8888.asia/",
        "https://www.epic8888.cc/",
        "https://www.epic8888.co/",
        "https://www.epic8888.com/"
      ],
      jimMy: [
        "http://epicwinfree8.com/",
        "http://www.epicwinfree8.com/",
        "https://epicwinfree8.com/",
        "https://www.epicwinfree8.com/"
      ],
      app88: [
        "http://epwin10.com/",
        "https://epwin10.com/",
        "http://www.epwin10.com/",
        "https://www.epwin10.com/"
      ],
      app2: [
        "http://epwin8.com/",
        "https://epwin8.com/",
        "http://www.epwin8.com/",
        "https://www.epwin8.com/"
      ],
      appFlyer: [
        "http://epwin10.com/",
        "https://epwin10.com/",
        "http://www.epwin10.com/",
        "https://www.epwin10.com/",
        "http://epwin8.com/",
        "https://epwin8.com/",
        "http://www.epwin8.com/",
        "https://www.epwin8.com/",
        "http://epwin11.com/",
        "https://epwin11.com/",
        "http://www.epwin11.com/",
        "https://www.epwin11.com/",
        "http://epwin12.com/",
        "https://epwin12.com/",
        "http://www.epwin12.com/",
        "https://www.epwin12.com/",
        "http://epwin13.com/",
        "https://epwin13.com/",
        "http://www.epwin13.com/",
        "https://www.epwin13.com/",
        "http://epwin14.com/",
        "https://epwin14.com/",
        "http://www.epwin14.com/",
        "https://www.epwin14.com/",
        "http://epwin15.com/",
        "https://epwin15.com/",
        "http://www.epwin15.com/",
        "https://www.epwin15.com/",
        "http://epicwin.ph/",
        "https://epicwin.ph/",
        "http://www.epicwin.ph/",
        "https://www.epicwin.ph/",
        "http://epicwinph88.com/",
        "https://epicwinph88.com/",
        "http://www.epicwinph88.com/",
        "https://www.epicwinph88.com/",
        "http://epicwin8.xyz/",
        "https://epicwin8.xyz/",
        "http://www.epicwin8.xyz/",
        "https://www.epicwin8.xyz/",
        "http://epic2win.site/",
        "https://epic2win.site/",
        "http://www.epic2win.site/",
        "https://www.epic2win.site/",
        "http://epic2win.net/",
        "https://epic2win.net/",
        "http://www.epic2win.net/",
        "https://www.epic2win.net/"
      ],
      app3: [
        "http://epwin11.com/",
        "https://epwin11.com/",
        "http://www.epwin11.com/",
        "https://www.epwin11.com/",
      ],
      app4: [
        "http://epwin12.com/",
        "https://epwin12.com/",
        "http://www.epwin12.com/",
        "https://www.epwin12.com/"
      ],
      app5: [
        "http://epwin13.com/",
        "https://epwin13.com/",
        "http://www.epwin13.com/",
        "https://www.epwin13.com/"
      ],
      app6: [
        "http://epwin14.com/",
        "https://epwin14.com/",
        "http://www.epwin14.com/",
        "https://www.epwin14.com/"
      ],
      app7: [
        "http://epwin15.com/",
        "https://epwin15.com/",
        "http://www.epwin15.com/",
        "https://www.epwin15.com/"
      ],
      globe1: [
        "http://epwin16.com/",
        "https://epwin16.com/",
        "http://www.epwin16.com/",
        "https://www.epwin16.com/"
      ],
      globe2: [
        "http://epwin17.com/",
        "https://epwin17.com/",
        "http://www.epwin17.com/",
        "https://www.epwin17.com/"
      ],
      globe3: [
        "http://epwin18.com/",
        "https://epwin18.com/",
        "http://www.epwin18.com/",
        "https://www.epwin18.com/"
      ],
      globe4: [
        "http://epwin19.com/",
        "https://epwin19.com/",
        "http://www.epwin19.com/",
        "https://www.epwin19.com/"
        // "http://эпвин.рус/",
        // "https://эпвин.рус/",
        // "http://www.эпвин.рус/",
        // "https://www.эпвин.рус/",
        // "https://xn--b1ampf3e.xn--p1acf/",
        // "http://xn--b1ampf3e.xn--p1acf/",
      ],
      // affiBlack:[
      //   "http://epicwin66.com/",
      //   "https://epicwin66.com/",
      //   "http://www.epicwin66.com/",
      //   "https://www.epicwin66.com/"
      // ],
      adsss:[
        "http://epicwinph.xyz/",
        "https://epicwinph.xyz/",
        "http://www.epicwinph.xyz/",
        "https://www.epicwinph.xyz/"
      ],
      pin:[
        "http://epicphjili.xyz/",
        "https://epicphjili.xyz/",
        "http://www.epicphjili.xyz/",
        "https://www.epicphjili.xyz/"
      ],
      bio:[
        "http://epicwin.fun/",
        "https://epicwin.fun/",
        "http://www.epicwin.fun/",
        "https://www.epicwin.fun/"
      ],
      tips:[
        "http://epicwin8.club/",
        "https://epicwin8.club/",
        "http://www.epicwin8.club/",
        "https://www.epicwin8.club/"
      ],
      bb3:[
        "http://epicwinph.site/",
        "https://epicwinph.site/",
        "http://www.epicwinph.site/",
        "https://www.epicwinph.site/"
      ],
      blogg:[
        "http://epicwinph.live/",
        "https://epicwinph.live/",
        "http://www.epicwinph.live/",
        "https://www.epicwinph.live/"
      ],
      slots:[
        "http://epicphjili.site/",
        "https://epicphjili.site/",
        "http://www.epicphjili.site/",
        "https://www.epicphjili.site/"
      ],
      facebooks:[
        "http://epicwin8.xyz/",
        "https://epicwin8.xyz/",
        "http://www.epicwin8.xyz/",
        "https://www.epicwin8.xyz/"
      ],
      hdmovie:[
        "http://epicwin8.info/",
        "https://epicwin8.info/",
        "http://www.epicwin8.info/",
        "https://www.epicwin8.info/"
      ],
      john1:[
        "http://epicwin8.site/",
        "https://epicwin8.site/",
        "http://www.epicwin8.site/",
        "https://www.epicwin8.site/"
      ],
      ss321:[
        "http://epicwin8.fun/",
        "https://epicwin8.fun/",
        "http://www.epicwin8.fun/",
        "https://www.epicwin8.fun/"
      ],
      ddf333:[
        "http://epicwinph.asia/",
        "https://epicwinph.asia/",
        "http://www.epicwinph.asia/",
        "https://www.epicwinph.asia/"
      ],
      as221:[
        "http://epicwinph.online/",
        "https://epicwinph.online/",
        "http://www.epicwinph.online/",
        "https://www.epicwinph.online/"
      ],
      tengsss:[
        "http://epicwin66.com/",
        "https://epicwin66.com/",
        "http://www.epicwin66.com/",
        "https://www.epicwin66.com/"
      ],
      moneymeme:[
        "http://epicwinph.website/",
        "https://epicwinph.website/",
        "http://www.epicwinph.website/",
        "https://www.epicwinph.website/"
      ],
      globee:[
        "http://epwin2.com/",
        "https://epwin2.com/",
        "http://www.epwin2.com/",
        "https://www.epwin2.com/"
      ],
      ee6688:[
        "http://epicwinvip.site/",
        "https://epicwinvip.site/",
        "http://www.epicwinvip.site/",
        "https://www.epicwinvip.site/"
      ],
      regina:[
        "http://epicwinjili.online/",
        "https://epicwinjili.online/",
        "http://www.epicwinjili.online/",
        "https://www.epicwinjili.online/"
      ],
      youtube:[
        "http://epicwinjili.site/",
        "https://epicwinjili.site/",
        "http://www.epicwinjili.site/",
        "https://www.epicwinjili.site/"
      ],
      instagram33:[
        "http://epicphwin.com/",
        "https://epicphwin.com/",
        "http://www.epicphwin.com/",
        "https://www.epicphwin.com/"
      ],
      tt444:[
        "http://epicjili.site/",
        "https://epicjili.site/",
        "http://www.epicjili.site/",
        "https://www.epicjili.site/"
      ],
      tt555:[
        "http://epicwin123.online/",
        "https://epicwin123.online/",
        "http://www.epicwin123.online/",
        "https://www.epicwin123.online/"
      ],
      f33:[
        "http://epicwin123.site/",
        "https://epicwin123.site/",
        "http://www.epicwin123.site/",
        "https://www.epicwin123.site/"
      ],
      r444:[
        "http://epicwin888.online/",
        "https://epicwin888.online/",
        "http://www.epicwin888.online/",
        "https://www.epicwin888.online/"
      ],
      e333:[
        "http://epicwin888.site/",
        "https://epicwin888.site/",
        "http://www.epicwin888.site/",
        "https://www.epicwin888.site/"
      ],
      d33:[
        "http://epic2win.xyz/",
        "https://epic2win.xyz/",
        "http://www.epic2win.xyz/",
        "https://www.epic2win.xyz/"
      ],
      s111:[
        "http://epicwinpera.xyz/",
        "https://epicwinpera.xyz/",
        "http://www.epicwinpera.xyz/",
        "https://www.epicwinpera.xyz/"
      ],
      s212:[
        "http://epicwinpera.co/",
        "https://epicwinpera.co/",
        "http://www.epicwinpera.co/",
        "https://www.epicwinpera.co/"
      ],
      ss222:[
        "http://epic2win.co/",
        "https://epic2win.co/",
        "http://www.epic2win.co/",
        "https://www.epic2win.co/"
      ],
      c44:[
        "http://epic2win.online/",
        "https://epic2win.online/",
        "http://www.epic2win.online/",
        "https://www.epic2win.online/"
      ],
      bb555:[
        "http://epic2win.net/",
        "https://epic2win.net/",
        "http://www.epic2win.net/",
        "https://www.epic2win.net/"
      ],
      gg555:[
        "http://epic2win.site/",
        "https://epic2win.site/",
        "http://www.epic2win.site/",
        "https://www.epic2win.site/"
      ],
      re866:[
        "http://epicwinpera.online/",
        "https://epicwinpera.online/",
        "http://www.epicwinpera.online/",
        "https://www.epicwinpera.online/"
      ],
      sd333:[
        "http://epicwinpera.net/",
        "https://epicwinpera.net/",
        "http://www.epicwinpera.net/",
        "https://www.epicwinpera.net/"
      ],
      gt666:[
        "http://epicwinpera.fun/",
        "https://epicwinpera.fun/",
        "http://www.epicwinpera.fun/",
        "https://www.epicwinpera.fun/"
      ],
      kk333:[
        "http://epic2win.live/",
        "https://epic2win.live/",
        "http://www.epic2win.live/",
        "https://www.epic2win.live/"
      ],
      h2222:[
        "http://epicperawin.xyz/",
        "https://epicperawin.xyz/",
        "http://www.epicperawin.xyz/",
        "https://www.epicperawin.xyz/"
      ],
      zz333:[
        "http://epwin.online/",
        "https://epwin.online/",
        "http://www.epwin.online/",
        "https://www.epwin.online/"
      ],
      s4451:[
        "http://epicperawin.co/",
        "https://epicperawin.co/",
        "http://www.epicperawin.co/",
        "https://www.epicperawin.co/"
      ],
      b222:[
        "http://epwin.xyz/",
        "https://epwin.xyz/",
        "http://www.epwin.xyz/",
        "https://www.epwin.xyz/"
      ],
      w333:[
        "http://epicperawin.online/",
        "https://epicperawin.online/",
        "http://www.epicperawin.online/",
        "https://www.epicperawin.online/"
      ],
      kk88:[
        "http://epicperawin.net/",
        "https://epicperawin.net/",
        "http://www.epicperawin.net/",
        "https://www.epicperawin.net/"
      ],
      k555:[
        "http://epicperawin.site/",
        "https://epicperawin.site/",
        "http://www.epicperawin.site/",
        "https://www.epicperawin.site/"
      ],
      s200:[
        "http://epwin.site/",
        "https://epwin.site/",
        "http://www.epwin.site/",
        "https://www.epwin.site/"
      ],
      // showPrompt: false,
      isIOS: false,
      showTutorial: false,
      showDownload: false,
      showLang: false,
      showTopbanner: true,
      fbp: null,
      pixelId: "",
      siteName:"",
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    accountID() {
      return this.$store.getters.accountID;
    },
    sessionToken() {
      return this.$store.getters.sessionToken;
    },
    getAvatar() {
      return this.$store.getters.getAvatar;
    },
    getCurrentLevel() {
      return this.$store.getters.getCurrentLevel;
    },
    getFbLink() {
      if (this.$store.getters.getSocialList.length > 0) {
        for (var x = 0; x < this.$store.getters.getSocialList.length; x++) {
          if (
            this.$store.getters.getSocialList[x].social_platform === "facebook"
          ) {
            return this.$store.getters.getSocialList[x].social_link;
          }
        }
        return "";
      } else {
        return "";
      }
    },
    getTgLink() {
      if (this.$store.getters.getSocialList.length > 0) {
        for (var x = 0; x < this.$store.getters.getSocialList.length; x++) {
          if (
            this.$store.getters.getSocialList[x].social_platform === "telegram"
          ) {
            return this.$store.getters.getSocialList[x].social_link;
          }
        }
        return "";
      } else {
        return "";
      }
    },
    getIgLink() {
      if (this.$store.getters.getSocialList.length > 0) {
        for (var x = 0; x < this.$store.getters.getSocialList.length; x++) {
          if (
            this.$store.getters.getSocialList[x].social_platform === "instagram"
          ) {
            return this.$store.getters.getSocialList[x].social_link;
          }
        }
        return "";
      } else {
        return "";
      }
    },
    getYtLink() {
      if (this.$store.getters.getSocialList.length > 0) {
        for (var x = 0; x < this.$store.getters.getSocialList.length; x++) {
          if (
            this.$store.getters.getSocialList[x].social_platform === "youtube"
          ) {
            return this.$store.getters.getSocialList[x].social_link;
          }
        }
        return "";
      } else {
        return "";
      }
    },
    getVip(){
      return this.$store.state.user.vip
    },
    getInboxList(){
      return this.$store.state.user.inbox.length
    }
    // downloadLink(){
    //   return window.location.protocol + "//" + window.location.hostname + "/new/download/epicwin.apk";
    // },
  },
  watch: {
    isLoggedIn(newState, oldState){
      if(newState){
        this.firstBalance()
        this.getMemberEwallet()
        this.getMemberBankList()
        this.getFavlist()
        // this.loginLog()
      }
    },
    $route(to, from) {
      this.currentPath = to.path;
      if (
        to.path === "/referral" ||
        to.path === "/deposit" ||
        to.path === "/profile" ||
        to.path === "/setting" ||
        to.path === "/withdrawal" ||
        to.path === "/statement" ||
        to.path === "/inbox" ||
        to.path === "/contactUs" ||
        to.path === "/promotions" || 
        to.path === "/livestream" ||
	      to.path === "/vip" ||
        to.path === "/ambassador"
      ) {
        this.showTop = true;
        this.showBalance = true;
      } else {
        this.showTop = false;
        this.showBalance = false;
      }
    },
    sessionToken(newState, oldState){
      var vm = this
      if(newState === '' || newState === undefined){
        // window._smartico_user_id = null;
        // window._smartico_language = null;
        // vm.$store.dispatch("user/setCurrentLevel", "");
      }
    }
  },
  created() {
    this.checkAnn();
    this.getSocialList();
    this.loadMetaPixel()
    this.loadCustom()
  },
  beforeMount() {
    this.getMobile();
    this.checkSize();
    // window.addEventListener("beforeinstallprompt", e => {
    //   e.preventDefault();
    //   this.triggerEvent = e;
    //   this.showPrompt = true;
    // });
  },
  updated(){
    if(!_.isEmpty(this.$route.params)){
      if(this.$route.params.checkProfile == true){
				this.showProfile = true
			}
    }
  },
  mounted() {
    var vm = this;
    this.checkDomain();
    this.currentPath = this.$router.currentRoute.path;
    if (
      this.$router.currentRoute.path === "/referral" ||
      this.$router.currentRoute.path === "/deposit" ||
      this.$router.currentRoute.path === "/profile" ||
      this.$router.currentRoute.path === "/setting" ||
      this.$router.currentRoute.path === "/withdrawal" ||
      this.$router.currentRoute.path === "/statement" ||
      this.$router.currentRoute.path === "/inbox" ||
      this.$router.currentRoute.path === "/contactUs" ||
      this.$router.currentRoute.path === "/promotions" || 
      this.$router.currentRoute.path === "/livestream" ||
      this.$router.currentRoute.path === "/vip" ||
      this.$router.currentRoute.path === "/ambassador"
    ) {
      this.showTop = true;
      this.showBalance = true;
    } else {
      this.showTop = false;
      this.showBalance = false;
    }
    
    $(".chat-close").click(function() {
      $(".chat-gif")
        .removeClass("d-block")
        .addClass("d-none");
      $(".chat-close")
        .removeClass("d-block")
        .addClass("d-none");
    });
    if (!_.isEmpty(this.$route.query)) {
      if(this.$route.query.promo){
        this.hideAnn = true
      }
      var site =
        window.location.protocol + "//" + window.location.hostname + "/";
      if (this.appFlyer.includes(site)) {
        if (this.$route.query.fbp) {
          this.fbp = this.$route.query.fbp;
          if (localStorage.getItem("fbp") === null) {
            localStorage.setItem("fbp", this.fbp);
          }
          if (this.$route.query.pixelId) {
            this.pixelId = this.$route.query.pixelId;
            if (localStorage.getItem("pixelId") === null) {
              localStorage.setItem("pixelId", this.pixelId);
            }
          }
          this.appflyerSubmit();
        }
      }
      if (this.isLoggedIn) {
        if (this.$route.query.tut) {
          this.gamification();
        }
        this.$router.replace(this.currentPath);
      }
      if (this.$route.query.promo) {
        var target = parseInt(this.$route.query.promo)
        this.$router.push("/promotions").catch(error =>{}).finally(() => {
          this.$nextTick(() => {
            EventBus.$emit('custom', target);
          });
        });
        
      }else{
        this.$router.replace("/");
      }
      // this.$router.replace("/");
    }
    if (this.$store.getters.isLoggedIn) {
      this.getBalance()
      this.getMemberVip()
      this.getInbox()
    }
    this.refreshBalance = setInterval(() => {
      if (this.$store.getters.isLoggedIn) {
        this.getBalance()
        this.getInbox()
      }
    }, 8000)
    this.refreshVip = setInterval(() => {
      if (this.$store.getters.isLoggedIn) {
        this.getMemberVip()
        // this.getInboxList()
      }
    }, 15000)
    
  },
  beforeDestroy: function() {
    clearInterval(this.refreshBalance)
    clearInterval(this.refreshVip)
    // clearInterval(this.refreshInbox)
    // clearInterval(this.continueRefreshInbox)
  },
  methods: {
    closeSidebar() {
      $('body').removeClass('hnb');
    },
    toggleSidebar(){
      // this.showSb = !this.showSb
      // if(this.showSb){
        
      // }else{

      // }
      $('body').toggleClass('hnb')
      setTimeout(function () {
          window.dispatchEvent(new Event('resize'));
      }, 400);
      return false
    },
    loadCustom(){
      var site = window.location.protocol + "//" + window.location.hostname + "/";
      if(this.kk333.includes(site)){
        const externalScript = document.createElement('script');
        externalScript.charset = 'UTF-8';
        externalScript.id = 'LA_COLLECT';
        externalScript.src = '//sdk.51.la/js-sdk-pro.min.js';
        externalScript.onload = () => {
          // Create the inline initialization script element
          const inlineScript = document.createElement('script');
          inlineScript.innerHTML = `
            LA.init({ id: "3JIA00tn1TrtKnYm", ck: "3JIA00tn1TrtKnYm" });
          `;
          // Append the inline script to the head
          document.head.appendChild(inlineScript);
        };
        document.head.appendChild(externalScript);
      }
    },
    loadMetaPixel(){
      var site = window.location.protocol + "//" + window.location.hostname + "/";
      if(this.tt555.includes(site)){
        const script = document.createElement('script');
        script.innerHTML = `
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '870418154955207');
          fbq('track', 'PageView');
        `;
        document.head.appendChild(script);
        const noscript = document.createElement('noscript');
        noscript.innerHTML = `
          <img height="1" width="1" style="display:none"
          src="https://www.facebook.com/tr?id=870418154955207&ev=PageView&noscript=1"
          />
        `;
        document.body.appendChild(noscript);
      }
      if(this.bb555.includes(site)){
        const script = document.createElement('script');
        script.innerHTML = `
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '2346123352256469');
          fbq('track', 'PageView');
        `;
        document.head.appendChild(script);
        const noscript = document.createElement('noscript');
        noscript.innerHTML = `
          <img height="1" width="1" style="display:none"
          src="https://www.facebook.com/tr?id=2346123352256469&ev=PageView&noscript=1"
          />
        `;
        document.body.appendChild(noscript);
      }
      if(this.tt555.includes(site)){
        const script = document.createElement('script');
        script.innerHTML = `
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '2998335763651149');
          fbq('track', 'PageView');
        `;
        document.head.appendChild(script);
        const noscript = document.createElement('noscript');
        noscript.innerHTML = `
          <img height="1" width="1" style="display:none"
          src="https://www.facebook.com/tr?id=2998335763651149&ev=PageView&noscript=1"
          />
        `;
        document.body.appendChild(noscript);
      }
      if(this.w333.includes(site)){
        const script = document.createElement('script');
        script.innerHTML = `
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '836408138561128');
          fbq('track', 'PageView');
        `;
        document.head.appendChild(script);

        const script2 = document.createElement('script');
        script2.innerHTML = `
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '556106040190305');
          fbq('track', 'PageView');
        `;
        document.head.appendChild(script2);

        const noscript = document.createElement('noscript');
        noscript.innerHTML = `
          <img height="1" width="1" style="display:none"
          src="https://www.facebook.com/tr?id=836408138561128&ev=PageView&noscript=1"
          />
        `;
        document.body.appendChild(noscript);

        const noscript2 = document.createElement('noscript');
        noscript.innerHTML = `
          <img height="1" width="1" style="display:none"
          src="https://www.facebook.com/tr?id=556106040190305&ev=PageView&noscript=1"
          />
        `;
        document.body.appendChild(noscript2);
      }
      if(this.kk88.includes(site)){
        const script = document.createElement('script');
        script.innerHTML = `
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '1231708791190092');
          fbq('track', 'PageView');
        `;
        document.head.appendChild(script);
        const noscript = document.createElement('noscript');
        noscript.innerHTML = `
          <img height="1" width="1" style="display:none"
          src="https://www.facebook.com/tr?id=1231708791190092&ev=PageView&noscript=1"
          />
        `;
        document.body.appendChild(noscript);
      }
      if(this.k555.includes(site)){
        const script = document.createElement('script');
        script.innerHTML = `
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '1263373218127949');
          fbq('track', 'PageView');
        `;
        document.head.appendChild(script);
        const noscript = document.createElement('noscript');
        noscript.innerHTML = `
          <img height="1" width="1" style="display:none"
          src="https://www.facebook.com/tr?id=1263373218127949&ev=PageView&noscript=1"
          />
        `;
        document.body.appendChild(noscript);
      }      
    },
    toProfile(){
      this.showProfile = false
      this.$router.push("/profile").catch(error =>{})
    },
    appflyerSubmit() {
      var vm = this;
      this.siteName = window.location.protocol + "//" +window.location.hostname
      var url = config.appflyerSubmit();
      this.$http
        .post(url, {
          "fbp": this.fbp,
          "pixelId": this.pixelId,
          "domain": this.siteName,
        })
        .then(
          successResponse => {
            if (successResponse) {
              if (typeof successResponse.data.status == "string") {
                this.feedback.success = successResponse.status == "1";
              } else {
                this.feedback.success = successResponse.status == 1;
              }
              this.feedback.status = successResponse.status;
              if (this.feedback.success == true) {
              } else {
              }
            } else {
            }
          },
          errorResponse => {
            console.log(errorResponse);
          }
        );
    },
    toggleLang() {
      this.showLang = !this.showLang;
    },
    checkDomain() {
      var site =
        window.location.protocol + "//" + window.location.hostname + "/";
      if (
        this.globeArray.includes(site) ||
        this.smartArray.includes(site) ||
        this.jimMy.includes(site) ||
        this.app88.includes(site) ||
        this.app2.includes(site) ||
        this.app3.includes(site) ||
        this.app4.includes(site) ||
        this.app5.includes(site) ||
        this.app6.includes(site) ||
        this.app7.includes(site) ||
        this.globe1.includes(site) ||
        this.globe2.includes(site) ||
        this.globe3.includes(site) ||
        this.globe4.includes(site) ||
        // this.affiBlack.includes(site) ||
        this.adsss.includes(site) ||
        this.pin.includes(site) ||
        this.bio.includes(site) ||
        this.tips.includes(site) ||
        this.bb3.includes(site) ||
        this.blogg.includes(site) ||
        this.slots.includes(site) ||
        this.facebooks.includes(site) ||
        this.hdmovie.includes(site) ||
        this.john1.includes(site) || 
        this.ss321.includes(site) ||
        this.ddf333.includes(site) ||
        this.as221.includes(site) ||
        this.tengsss.includes(site) ||
        this.moneymeme.includes(site) ||
        this.globee.includes(site) ||
        this.ee6688.includes(site) ||
        this.regina.includes(site) ||
        this.youtube.includes(site) ||
        this.instagram33.includes(site) ||
        this.tt444.includes(site) ||
        this.tt555.includes(site) ||
        this.f33.includes(site) ||
        this.r444.includes(site) ||
        this.e333.includes(site) ||
        this.d33.includes(site) ||
        this.s111.includes(site) ||
        this.s212.includes(site) ||
        this.ss222.includes(site) || 
        this.c44.includes(site) ||
        this.bb555.includes(site) ||
        this.gg555.includes(site) || 
        this.re866.includes(site) ||
        this.sd333.includes(site) ||
        this.gt666.includes(site) ||
        this.kk333.includes(site) ||
        this.h2222.includes(site) ||
        this.zz333.includes(site) ||
        this.s4451.includes(site) ||
        this.b222.includes(site) ||
        this.w333.includes(site) ||
        this.kk88.includes(site) ||
        this.k555.includes(site) ||
        this.s200.includes(site)
      ) {
        $("#regModal").modal("show");
      }
    },
    getMobile() {
      let isMobile = {
        Android: function() {
          return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function() {
          return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function() {
          return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function() {
          return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function() {
          return navigator.userAgent.match(/IEMobile/i);
        },
        any: function() {
          return (
            isMobile.Android() ||
            isMobile.BlackBerry() ||
            isMobile.iOS() ||
            isMobile.Opera() ||
            isMobile.Windows()
          );
        }
      };

      if (isMobile.iOS()) {
        this.isIOS = true;
        this.showTutorial = true;
        // this.showTopbanner = true;
        this.showDownload = false
      } else {
        this.isIOS = false;
        this.showTutorial = false;
        // this.showTopbanner = false;
        this.showDownload = true
      }
    },
    hideTopbanner(){
      this.showTopbanner = false
    },
    hideDownload(){
      this.showDownload = false
    },
    hideTutorial() {
      this.showTutorial = false;
    },
    openTutorial() {
      $("#modal-tutorial").modal("show");
    },
    gamification() {
      // console.log('here', window._smartico)
      // window._smartico.dp('dp:gf');
      _smartico.dp("dp:gf");
    },
    rules() {
      // _smartico.dp("dp:gf_section&id=91")  //rules
      _smartico.dp("dp:gf_saw"); //wheel
    },
    eventAction() {
      if (this.isLoggedIn) {
        $("#leaderboard-modal").modal("show");
        // window._smartico.showWidget('ui-widget', { iframe: 'testIframe', zoom: 1, height: 'auto', wuuid: '100005/79d12290-d465-11ee-9aa0-0228c1221b89', id: 2} )
      } else {
        this.openLogModal();
      }
    },
    toggleIcon() {
      this.hideIcon = !this.hideIcon;
    },
    openModal(target) {
      $(target).modal("show");
    },
    getDisplayWord() {
      switch (this.$router.currentRoute.path) {
        case "/referral":
          return this.$t("ui.referral");
        case "/profile":
          return this.$t("ui.profile");
        case "/deposit":
          return this.$t("ui.deposit");
        case "/withdrawal":
          return this.$t("ui.withdrawal");
        case "/statement":
          return this.$t("ui.statement");
        case "/inbox":
          return this.$t("ui.inbox");
        case "/contactUs":
          return this.$t("ui.follow_us");
        case "/promotions":
          return this.$t("ui.promotion");
        case "/livestream":
          return "Live Stream"
        case "/ambassador":
          return "Ambassador"
        case "/setting":
          return this.$t('ui.setting');
	      case "/vip":
          return "VIP";
      }
    },
    
    checkSize() {
      if ($(window).width() < 681) {
        this.showMobile = true;
      } else {
        this.showMobile = false;
      }
    },
    openChat() {
      LiveChatWidget.call("maximize");
    },
    // triggerDownload() {
    //   this.triggerEvent.prompt();
    //   //user response
    //   this.triggerEvent.userChoice.then(response => {
    //     if (response.outcome === "accepted") {
    //       this.showPrompt = false;
    //     } else {
    //     }
    //   });
    // },
    getSocialList() {
      this.$store
        .dispatch("user/getSocialList", {})
        .then(response => {
          if (response.success == true) {
            // this.socialList = response.data.value
          } else {
            if (typeof response.status != "object") {
              this.$helpers.showDialog(
                this.$t("ui.attention"),
                this.$t("message.list." + response.status),
                "info",
                this
              );
            }
          }
        })
        .catch(response => {
          if (typeof response.status != "object") {
            this.$helpers.showDialog(
              this.$t("ui.attention"),
              this.$t("message.list." + response.status),
              "info",
              this
            );
          }
        });
    },
    firstBalance(){
      var vm = this
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getBalance", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }              
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }  
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
          });
      }
    },
    getBalance() {
      if (this.sessionToken) {
        var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getBalance", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }              
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              clearInterval(this.refreshBalance)
              this.$swal({
                title: vm.$tc("ui.attention"),
                confirmButtonText: "OK",
                text: vm.$t("message.list." + response.status),
                type: "info"
              }).then(result => {
                vm.logout()
              });
            }  
            if(response?.status?.status == 0){
              console.log('Network Error')
            }
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
          });
      }
    },
    getMemberVip(){
      if (this.sessionToken) {
        var vm = this
        this.loading = true
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getMemberVip", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
            this.loading = false
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              clearInterval(this.refreshVip)
              this.$swal({
                title: vm.$tc("ui.attention"),
                confirmButtonText: "OK",
                text: vm.$t("message.list." + response.status),
                type: "info"
              }).then(result => {
                vm.logout()
              });
            }
            if(response?.status?.status == 0){
              console.log('Network Error')
            }
            this.loading = false
          })
      }
    },
    getInbox(){
      if(this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.loading = true
        this.$store
          .dispatch("user/getInbox", { account_id, auth_token })
          .then(response => {
            this.loading = false
            this.feedback.success = response.success
            this.feedback.status = response.status
            if (this.feedback.success == true) {
            } else {
              this.feedback.status = this.$t("error." + response.status)
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            this.loading = false
            this.feedback.success = false
            var vm = this
            if((typeof response.status) != 'object'){
              clearInterval(this.refreshBalance)
              this.$swal({
                title: vm.$tc("ui.attention"),
                confirmButtonText: "OK",
                text: vm.$t("message.list." + response.status),
                type: "info"
              }).then(result => {
                vm.logout()
              });
              if(response?.status?.status == 0){
                console.log('Network Error')
              }
            }
          });
      }
    },
    getMemberEwallet(){
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getMemberEwallet", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }    
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }
    },
    getMemberBankList() {
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getMemberBankList", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
							
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }    
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }
    },
    getFavlist(){
      if (this.sessionToken) {
				var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getFavlist", { account_id, auth_token})
          .then(response => {
            if (response.success == true) {
							// console.log(response)
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }
    },
    checkAnn(){
      this.$store
        .dispatch("user/getAnnBanner")
        .then(response => {
          this.loading = false;
          this.feedback.success = response.success
          if (this.feedback.success == true) {
            if(response.annBeforeLog === true){
              if (this.hideAnn == true) {
                  
              }else{
                if(!this.isLoggedIn){
                  $("#annModal").modal("show");
                }
              }
              
            }
          } else {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
            }       
          }
        })
        .catch(response => {
          this.loading = false;
          var vm = this;
          if((typeof response.status) != 'object'){
            this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
          }
        });
      // if(!this.$store.getters.isLoggedIn){
      //   if(this.$store.state.user.annBeforeLog === true){
      //     $("#modal-banner").modal("show");
      //   }
      // }
    },
    logout() {
      this.$store
        .dispatch("user/logout")
        .catch(err => {})
    },
  }
};
</script>
<style lang="scss" scoped>
.before-log {
  grid-template-columns: 50% 50%;
}
.article-view {
  @media (min-width: 681px) {
    padding-bottom: 0 !important;
  }
}
</style>
